window.addEventListener('load', () => {
  const productPriceElement = document.querySelector('.mutable-product-price'),
        comparePriceElement = document.querySelector('.mutable-compare-price'),
        savingPriceElement = document.querySelector('.mutable-saving-price'),
        dropdownSelector = document.querySelector('.single-option-selector');

  let variantList;

  if (dropdownSelector) {
      variantList = dropdownSelector.querySelectorAll('option');
  } else {
      console.warn('Dropdown selector not found on the page.');
  }

  appendPriceDiffToDropdownOptions();
  changePriceLabelsOnSelect();

  // Trigger the change event immediately so the price labels update on load.
  $(dropdownSelector).trigger('change');

  function appendPriceDiffToDropdownOptions(){
    if (!variantList) return;

    const lowestProductPrice = dropdownSelector.dataset.lowestProductPrice;
    if (!lowestProductPrice) {
      console.warn('Lowest product price not set.');
      return;
    }

    variantList.forEach(variantOption => {
      const variantPrice = variantOption.dataset.variantPrice;
      const priceDifference = variantPrice - lowestProductPrice;

      if (priceDifference > 0) {
        variantOption.innerHTML += ` +$${priceDifference % 100 === 0 ? priceDifference / 100 : (priceDifference / 100).toFixed(2)}`;
      }
    });
  }

  function changePriceLabelsOnSelect() {
    $(dropdownSelector).on('change', function(event) {
      // Get the selected option using jQuery
      const $selectedOption = $(this).find('option:selected');
      const selectedVariantPrice = parseFloat($selectedOption.data('variantPrice')) / 100,
            selectedVariantCompareAtPrice = parseFloat($selectedOption.data('variantCompareAtPrice')) / 100,
            selectedVariantSavePrice = (parseFloat($selectedOption.data('variantCompareAtPrice')) - parseFloat($selectedOption.data('variantPrice'))) / 100;

      // Update price elements
      if (savingPriceElement) $(savingPriceElement).html(`$${selectedVariantSavePrice.toFixed(2)}`);
      if (comparePriceElement) $(comparePriceElement).html(`$${selectedVariantCompareAtPrice.toFixed(2)}`);
      if (productPriceElement) $(productPriceElement).html(`$${selectedVariantPrice.toFixed(2)}`);

      // Get inventory details from data attributes
      
      
    });
  }
});
